export const GET_HASH_START = 'GET_HASH_START';
export const GET_HASH_SUCCESS = 'GET_HASH_SUCCESS';
export const GET_HASH_FAIL = 'GET_HASH_FAIL';
export const GET_HASH_RESET = 'GET_HASH_RESET';
